import { Edge } from "@xyflow/react";
import { UndoRedoState } from "./flow-editor-types";

export function undoRedoStateEquals(
  a: UndoRedoState,
  b: UndoRedoState,
): boolean {
  if (a.selectedId !== b.selectedId) return false;

  if (a.steps.size !== b.steps.size) return false;
  for (const [key, valueA] of a.steps) {
    const valueB = b.steps.get(key);
    if (valueA !== valueB) return false;
  }

  if (a.userNodePositions.size !== b.userNodePositions.size) return false;
  for (const [key, posA] of a.userNodePositions) {
    const posB = b.userNodePositions.get(key);
    if (!posB || posA.x !== posB.x || posA.y !== posB.y) return false;
  }

  return true;
}

export function edgesAreEqual(edges1: Edge[], edges2: Edge[]): boolean {
  if (edges1.length !== edges2.length) return false;

  const createEdgeKey = (edge: Edge) =>
    `${edge.id}|${edge.source}|${edge.target}|${edge.sourceHandle || ""}`;

  const edges1Map = new Map(edges1.map((edge) => [createEdgeKey(edge), edge]));

  for (const edge2 of edges2) {
    const key = createEdgeKey(edge2);
    if (!edges1Map.has(key)) {
      return false;
    }
  }

  return true;
}
